module.exports = __webpack_public_path__ + "img/login.6406b232.jpg";